import { resolveResourceType } from '@/shared/resourceModuleParity'

import type { GuidanceAction } from './types'

/**
 * Onde encontrar missões, num evento que tem missões configuradas e nenhuma
 * disponível para o participante agora.
 *
 * Uma ação só. O design chegou a prever também uma ação por pré-requisito de
 * jornada, "quando as missões dependem de progressão" — e o mecanismo não
 * existe: `Mission` não declara trava alguma, e `useMissionsListView` filtra
 * apenas por `uiStatus`. Os campos `locked`, `locked_until`,
 * `unlock_after_previous_level` e `unlock_mission_id` são de `Level`.
 */
export const buildMissionsGuidance = (
  missionsTotal: number
): GuidanceAction[] => {
  if (missionsTotal <= 0) return []

  const resolved = resolveResourceType('Mission')

  return [
    {
      key: 'missions-module',
      resourceType: 'Mission',
      title: 'Veja as missões do evento',
      instruction: `Acesse ${resolved.sectionPrep} para conferir o que já está disponível.`,
      to: resolved.route
    }
  ]
}
